"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const fastcheckoutbrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 68",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-fastcheckoutbrand01` : '') + (description ? ` desc-fastcheckoutbrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-fastcheckoutbrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-fastcheckoutbrand01"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.841 5H3.174a2 2 0 0 0-2 2v29.333l.019.272a1.999 1.999 0 0 0 1.981 1.728h7.742v27.334c0 1.968 2.546 2.752 3.654 1.125l24.924-36.586.14-.24c.65-1.294-.28-2.886-1.793-2.886l-9.037-.002L39.583 7.983C40.335 6.65 39.372 5 37.84 5Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "a",
    style: {
      "maskType": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "1",
    y: "5",
    width: "39",
    height: "63"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.175 5h38.67v62.67H1.175V5Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1a1 1 0 0 1 1-1h36.174a1 1 0 0 1 .88 1.475L25.846 24.087h11.328a1 1 0 0 1 .838 1.546L12.004 65.546A1 1 0 0 1 10.166 65V34H1a1 1 0 0 1-1-1V1Zm2 1v30h9.166a1 1 0 0 1 1 1v28.634l23.163-35.547h-11.16a1 1 0 0 1-.88-1.476L35.499 2H2Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = fastcheckoutbrand01;